import { render, staticRenderFns } from "./insuranceFinancialDetails.vue?vue&type=template&id=ca4c61be&"
import script from "./insuranceFinancialDetails.vue?vue&type=script&lang=js&"
export * from "./insuranceFinancialDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports